import { postQuotationView } from "@api/index";
import { updateQuotation } from "@redux/slices/SHIELD_STARTER/step2Slice";
import { generatePlanOverView } from "./generatePlanOverView";
import { updatePlanOverview } from "@redux/slices/SHIELD_STARTER/step2Slice";

async function fetchSqsQuotation(
  whomToBuy: string,
  policyName: string,
  dispatch: Function,
  promoCode?: string,
  singpassObjectInStore?: Object,
  campaignCode?: string
) {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await postQuotationView(
        whomToBuy,
        policyName,
        promoCode,
        singpassObjectInStore,
        campaignCode
      );
      dispatch(updateQuotation(data.data));
      if (data.data && typeof dispatch === "function") {
        const planOverview = generatePlanOverView(data.data, () => {});
        dispatch(updatePlanOverview(planOverview));
        resolve("done");
      }
    } catch (e) {
      reject("Rejected");
    }
  });
}

export default fetchSqsQuotation;
